<template>
  <span class="tw-text-lg tw-font-medium tw-text-primary-grey-800">
    <slot />
  </span>
</template>
